module.exports = __webpack_public_path__ + "static/draperies-valances-eabaf23eb8b6bd31afb94a5553e6eab9.png";